import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UpdateApiKeyState } from "./types";
import { IApiKey } from "@/shared/api/settings";

const initialState: UpdateApiKeyState = {
    isUpdateApiKeyModalOpen: false,
    isRecreateApiKeyModalOpen: false,
    currentApiKey: undefined,
    onRecreate: null,
    onUpdate: null
}

interface OpenUpdateApiKeyModal {
    data: IApiKey
    onSuccess?: () => void
}

interface OpenRecreateApiKeyModal {
    data: IApiKey
    onSuccess?: () => void
}

export const updateApiKeySlice = createSlice({
    name: 'updateApiKey',
    initialState,
    reducers: {
        openUpdateApiKeyModal: (state, action: PayloadAction<OpenUpdateApiKeyModal>) => {
            state.isUpdateApiKeyModalOpen = true
            state.onUpdate = action.payload.onSuccess
            state.currentApiKey = action.payload.data
        },
        closeUpdateApiKeyModal: (state) => {
            state.isUpdateApiKeyModalOpen = false
        },
        openRecreateApiKeyModal: (state, action: PayloadAction<OpenRecreateApiKeyModal>) => {
            state.isRecreateApiKeyModalOpen = true
            state.onRecreate = action.payload.onSuccess
            state.currentApiKey = action.payload.data
        },
        closeRecreateApiKeyModal: (state) => {
            state.isRecreateApiKeyModalOpen = false
        },
    }
})

export default updateApiKeySlice.reducer
export const {
    closeUpdateApiKeyModal,
    openUpdateApiKeyModal,
    openRecreateApiKeyModal,
    closeRecreateApiKeyModal
} = updateApiKeySlice.actions